(function($, exports) {

	var tabs, $tabs;

	function setVars() {
		$tabs = $('.c-information-tabs__nav').find('a');
		tabs = getTabs();
	}

	function getTabs() {
		var tabs = [];

		$tabs.each(function() {
			tabs.push($(this).data('type'));
		});

		return tabs;
	}

	function createNavLink(type, title) {
		var link = "<a class='c-information-tabs__link' href='#' data-type='" + type + "'>" + title + "</a>";

		return link;
	}

	function setNavBottom(type) {
		var $prev = $('.c-information-tabs__nav-bottom__prev');
		var $next = $('.c-information-tabs__nav-bottom__next');
		var $nav = $('.c-information-tabs__nav');

		tabs.forEach(function(tab, index) {
			if(type === tab) {
				if(index > 0) {
					var title = $nav.find("[data-type='" + tabs[index - 1] + "']").html();
					$prev.html(createNavLink(tabs[index - 1], title));
				} else {
					$prev.html('');
				}

				if(index < (tabs.length-1)) {
					var title = $nav.find("[data-type='" + tabs[index + 1] + "']").html();
					$next.html(createNavLink(tabs[index + 1], title));
				} else {
					$next.html('');
				}

				return;
			}
		});
	}

	function switchTab(type) {
		var $content = $('.c-information-tabs__content');
		$content.removeClass('is-active');
		$tabs.removeClass('is-active');

		$('.c-information-tabs__left').find("[data-type='" + type + "']").addClass('is-active');
		$('.c-information-tabs__nav').find("[data-type='" + type + "']").addClass('is-active');

	}

	function linkListener(e) {
		var $link = $(this);
		var type = $link.data('type');
		e.preventDefault();
		switchTab(type);
		setNavBottom(type);
	}


	exports.init = function() {
		setVars();
		$('.c-information-tabs').on('click', '.c-information-tabs__link', linkListener);

		setNavBottom('consultation');
	};
	
})(jQuery, this.INFORMATIONTABS = {});